import RelatedArticlesComponent from "../../../../components/help/RelatedArticlesComponent.tsx";
import {imageMap} from "../../../../images/imageMap.ts";
import {Link} from "react-router-dom";
import Routing from "../../../../Routing.ts";

export default function BetalingAfvistArticle() {
    return (
        <>
            <article className="help-article-content">
                <div className="article article--connect">
                    <div className="paragraph">
                        <p>
                            Du kan betale din regning på Mit Hiper ved at trykke på den røde notifikation om, at du har en ubetalt regning.
                        </p>
                        <p>
                            Bliver din betaling stadig afvist, kan du tjekke nedenstående:
                        </p>
                    </div>
                </div>

                <div className="article article--connect">
                    <div className="paragraph">
                        <h3>Er der ikke dækning på kortet?</h3>
                        <p>
                            Sørg for at der er dækning på kortet.
                            Har du tilkoblet et nyt kort, skal du tjekke at det er aktivt.
                        </p>
                    </div>
                </div>

                <div className="article article--connect">
                    <div className="paragraph">
                        <h3>Har du flere abonnementer?</h3>
                        <p>
                            Tjek at betalingskortet er tilføjet på alle abonnementerne i Mit Hiper. Det nye kort skal opdateres på alle abonnementer.
                        </p>
                    </div>
                    <img
                        className="paragraph-image box-shadow"
                        src={imageMap.help.subscription.selfcare_multiple_profiles}
                        alt="Grafik der illustrerer hvor man kan skifte profil."
                    />
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h3>Har du mistet eller fået spærret dit kort?</h3>
                        <p>
                            <Link to={Routing.Contact.Index}>Kontakt os</Link> hurtigst muligt. Vi finder en løsning og rykker din regning, så du undgår rykkere.
                        </p>
                    </div>
                </div>
            </article>

            <RelatedArticlesComponent
                articles={[
                    {
                        "category": "regning-og-betaling",
                        "article": "forstaa-din-regning",
                        "name": "Forstå din regning"
                    },
                    {
                        "category": "regning-og-betaling",
                        "article": "betalingsmuligheder",
                        "name": "Betalingsmuligheder"
                    },
                    {
                        "category": "regning-og-betaling",
                        "article": "mistet-kort",
                        "name": "Jeg har mistet mit betalingskort"
                    },
                    {
                        "category": "regning-og-betaling",
                        "article": "internet-betalt-af-arbejdsgiver",
                        "name": "Min arbejdsgiver skal betale for mit internet"
                    }
                ]}
            />
        </>
    )
}
